import GetCallLogsRequestModelBase from '../_generated/modelBases/get-call-logs-request-model-base';

export default class GetCallLogsRequestModel extends GetCallLogsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
